import React, { useState } from 'react';
import { FaHeart, FaSlidersH, FaPlus, FaEdit, FaBirthdayCake } from 'react-icons/fa';
import './ProcessGuidePanel.css';

/**
 * Inline flex-row process guide panel.
 * The sidebar (? button + step list) sits to the left of children.
 * When the panel opens the sidebar expands and children shift right.
 *
 * steps: [{ label, sub, action?, final? }]
 * topPad: number (px) — top padding for the content column (default 0)
 */
const ProcessGuidePanel = ({ steps = [], userRole, allowedRoles = ['Buyer'], children, topPad = 0, column = false, rightElement = null }) => {
  const [show, setShow] = useState(false);
  const [infoStep, setInfoStep] = useState(null);

  if (!allowedRoles.includes(userRole)) {
    return children ? <>{children}</> : null;
  }

  return (
    <>
      <div className={`pgp-host${show ? ' pgp-host--open' : ''}${column ? ' pgp-host--column' : ''}`}>
        <div className="pgp-sidebar">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <button
              className="pgp-toggle"
              onClick={() => setShow(v => !v)}
              title="How it works"
            >
              {show
                ? <span className="pgp-toggle-arrow">◀</span>
                : <span className="pgp-toggle-q">?</span>
              }
            </button>
            {rightElement && <div style={{ marginLeft: 'auto' }}>{rightElement}</div>}
          </div>
          {show && <div className="pgp-panel">
            <div className="pgp-panel-inner">
              {steps.map((step, i, arr) => (
                <React.Fragment key={step.label}>
                  <div className={`pgp-step${step.action ? ' pgp-step-action' : ''}${step.or ? ' pgp-step-or' : ''}${step.final ? ' pgp-step-final' : ''}`}>
                    <div className="pgp-dot">
                      {step.icon ?? (step.final ? '✓' : (i + 1))}
                    </div>
                    <div className="pgp-text">
                      <div className="pgp-label">{step.label}</div>
                      <div className="pgp-sub">{step.sub}</div>
                    </div>
                    {step.info && (
                      <button
                        className="pgp-info-btn"
                        onClick={e => { e.stopPropagation(); setInfoStep(step); }}
                        title="More info"
                      >?</button>
                    )}
                  </div>
                  {i < arr.length - 1 && (
                    arr[i + 1].or
                      ? <div className="pgp-or">OR</div>
                      : <div className="pgp-arrow">↓</div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>}
        </div>
        <div className="pgp-content" style={topPad ? { paddingTop: topPad } : {}}>
          {children}
        </div>
      </div>
      {infoStep && (
        <div className="pgp-info-overlay" onClick={() => setInfoStep(null)}>
          <div className="pgp-info-modal" onClick={e => e.stopPropagation()}>
            <button className="pgp-info-close" onClick={() => setInfoStep(null)}>✕</button>
            {infoStep.info.image && (() => {
              const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
              const src = isDark && infoStep.info.darkImage ? infoStep.info.darkImage : infoStep.info.image;
              return <img src={src} alt="Help" className="pgp-info-img" />;
            })()}
            {infoStep.info.text && (
              <p className="pgp-info-text">{infoStep.info.text}</p>
            )}
            {infoStep.info.notes && infoStep.info.notes.length > 0 && (
              <div className="pgp-info-notes">
                {infoStep.info.notes.map((note, i) => (
                  <div key={i} className="pgp-info-note"><span className="pgp-info-note-num">{i + 1}.</span>{note}</div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProcessGuidePanel;
